import { render } from "./CreatePlacement.vue?vue&type=template&id=647c0b19"
import script from "./CreatePlacement.vue?vue&type=script&lang=js"
export * from "./CreatePlacement.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__